var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "v-menu",
        {
          attrs: { "nudge-width": 200, "open-on-hover": "", "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b({ attrs: { icon: "" } }, "v-btn", attrs, false),
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { color: _vm.color } }, [
                        _vm._v(_vm._s(_vm.icon)),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c(
            "v-card",
            [
              _vm.title
                ? _c(
                    "v-app-bar",
                    { staticClass: "elevation-0", attrs: { dense: "" } },
                    [
                      _c(
                        "v-toolbar-title",
                        { staticClass: "text-subtitle-1" },
                        [_vm._v(_vm._s(_vm.title))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-card-text", [_vm._t("card-text")], 2),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }